import { TableBaseCols } from '@ge/feat-reporting/components/widgets/table-widget/table-base-cols';

// All available columns and groups for completed work
export const InternalInspectionDamagesColumns = {
  GROUP_SELECTED: TableBaseCols.GROUP_SELECTED,
  SELECTED: TableBaseCols.SELECTED,

  GROUP_COLUMNS: 'Columns',
  ASSET: 'Asset',
  MODEL: 'Model',
  COMPONENT: 'Component',
  LOCATION: 'Location',
  DAMAGE: 'Damage',
  PAC: 'pacNumber',
  CATEGORY: 'Category',
  P50: 'p50',
  P90: 'p90',
  SERIAL_NUMBER: 'Serial Number',
  MANUFACTURER: 'Manufacturer',
  PART: 'Part',
};

// Completed work table configuration
export const internalInspectionDamagesColumnsDefs = {
  [InternalInspectionDamagesColumns.GROUP_COLUMNS]: {
    align: 'left',
    labels: [
      {
        a11yKey: 'external_damages.columns.group_columns',
        a11yDefault: 'Columns',
      },
    ],
    cols: {
      [InternalInspectionDamagesColumns.ASSET]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.asset_name',
            a11yDefault: 'Asset',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalInspectionDamagesColumns.MODEL]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.model',
            a11yDefault: 'Model',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalInspectionDamagesColumns.COMPONENT]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.component',
            a11yDefault: 'Component',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalInspectionDamagesColumns.LOCATION]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.location',
            a11yDefault: 'Location',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalInspectionDamagesColumns.DAMAGE]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.damage',
            a11yDefault: 'Damage',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalInspectionDamagesColumns.PAC]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.pac',
            a11yDefault: 'PAC #',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalInspectionDamagesColumns.PART]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.part',
            a11yDefault: 'Part',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalInspectionDamagesColumns.CATEGORY]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.category',
            a11yDefault: 'Category',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalInspectionDamagesColumns.MANUFACTURER]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.manufacturer',
            a11yDefault: 'Manufacturer',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalInspectionDamagesColumns.P50]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.rul_50',
            a11yDefault: 'RUL P50',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalInspectionDamagesColumns.P90]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.rul_90',
            a11yDefault: 'RUL P90',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalInspectionDamagesColumns.SERIAL_NUMBER]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.serial_number',
            a11yDefault: 'Serial Number',
          },
        ],
        cell: {
          align: 'left',
        },
      },
    },
  },
};

export const InternalInspectionDamagesColumnsDefaultCols = [
  {
    id: InternalInspectionDamagesColumns.GROUP_COLUMNS,
    ignoreTemplateConfig: true,
    cols: [
      {
        id: InternalInspectionDamagesColumns.ASSET,
        visible: true,
      },
      {
        id: InternalInspectionDamagesColumns.MODEL,
        visible: false,
        ignoreTemplateConfig: true,
      },
      {
        id: InternalInspectionDamagesColumns.COMPONENT,
        visible: true,
      },
      {
        id: InternalInspectionDamagesColumns.LOCATION,
        visible: true,
      },
      {
        id: InternalInspectionDamagesColumns.DAMAGE,
        visible: true,
      },
      {
        id: InternalInspectionDamagesColumns.PAC,
        visible: true,
      },
      {
        id: InternalInspectionDamagesColumns.PART,
        visible: false,
        ignoreTemplateConfig: true,
      },
      {
        id: InternalInspectionDamagesColumns.CATEGORY,
        visible: true,
      },
      {
        id: InternalInspectionDamagesColumns.MANUFACTURER,
        visible: false,
        ignoreTemplateConfig: true,
      },
      {
        id: InternalInspectionDamagesColumns.P50,
        visible: true,
      },
      {
        id: InternalInspectionDamagesColumns.P90,
        visible: true,
      },
      {
        id: InternalInspectionDamagesColumns.SERIAL_NUMBER,
        visible: false,
        ignoreTemplateConfig: true,
      },
    ],
  },
];

export const PerformanceStateKeys = {
  CONFIG_STATE: 'configState',
};
